import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { EmptyStringValidator, MustMatch } from '@app/_helpers';
import { orderType, Signup } from '@app/_models';
import { Candidate, CaseLegalForm, CurrentAddress, Order } from '@app/_models/orders/shared';
import { Country, County, State } from '@app/_models/signups/geography';
import { AlertService, DashboardService, GeographyService, OrderService, SignupService } from '@app/_services';
import { TooltipMessageService } from '@app/_services/toolservice.service';
import { breakpointPixels, FadvIconLibraryService, FadvLoaderComponent, FadvModalComponent } from '@fa-switch-sharedservices/ng-elements';
import { Subscription } from 'rxjs';
import { PartnerComponent } from '../partner.component';

@Component({
  selector: 'app-partner-invite',
  templateUrl: './partner-invite.component.html',
  styleUrls: ['./partner-invite.component.css']
})
export class PartnerInviteComponent implements OnInit {

  form: UntypedFormGroup;
  loading = false;
  submitted = false;
  orderType = orderType;
  requireMiddleName = false;
  states: State[];
  countries: Country[];
  counties: County[];
  selectedState: string;
  selectedCounty: string;
  signup: Signup;
  orderHeaderVerbiage: string;
  orderSubHeaderVerbiage: string;
  middleNameToggle: Subscription;
  order: Order;
  formModalOpen = false;
  inviteOrder = true;
  requireDL = false;
  displayInvite = false;
  esignGuid = "C814878C-2750-4E17-BFBF-FCA0CBD60B13";
  disclosureGuid = "C814878C-2750-4E17-BFBF-FCA0CBD60B14";
  stateFormsGuid = "C814878C-2750-4E17-BFBF-FCA0CBD60B16";
  authorizationGuid = "C814878C-2750-4E17-BFBF-FCA0CBD60B15";
  candidateEsignAuth = "";
  candidateDisclosure = "";
  candidateAuthorization = "";
  candidateStateForms = "";
  ListCaseLegalForms: CaseLegalForm[] = [];
  CaseLegalForm: CaseLegalForm;
  backButtonAlignment: string = "right";
  nextButtonAlignment: string = "left";
  innerWidth: number = window.innerWidth;

  @ViewChild('consentmodal') consentmodal!: FadvModalComponent;
  @ViewChild('loader') loader: FadvLoaderComponent;
  @ViewChild('termsmodal') termsmodal!: FadvModalComponent;
  @ViewChild('electronicsignaturemodal') electronicsignaturemodal!: FadvModalComponent;
  @ViewChild('disclosuremodal') disclosuremodal!: FadvModalComponent;
  @ViewChild('authorizationmodal') authorizationmodal!: FadvModalComponent;
  @ViewChild('stateformsmodal') stateformsmodal!: FadvModalComponent;

  addressTooltip: string;
  legalNameTooltip: string;

  constructor(private formBuilder: UntypedFormBuilder,
    private router: Router,
    private signupService: SignupService,
    private cdref: ChangeDetectorRef,
    private partnerComponent: PartnerComponent,
    private appComponent: AppComponent) {  }

  get candidate() { return this.form.get('candidate') as UntypedFormGroup };

  ngOnInit(): void {
    this.handleGetSignup();
    this.buildForm();   
    this.partnerComponent.setStep(this.router.url);
    this.orderHeaderVerbiage = "Applicant Details";
    this.orderSubHeaderVerbiage = "We Will Email Your Applicant Instructions So They Can Easily Complete Their Details and Provide Consent. We Recommend Informing Your Applicant That They Should Expect an Email From First Advantage."
  }

  @HostListener('window:resize', ['$event'])

  onResize($event) {
    this.innerWidth = window.innerWidth;
    this.handleViewChange();
  }

  handleGetSignup(){
    this.signup = this.signupService.getSignup();
    this.signup.ordertype = orderType.invite;
    if (this.signup.order == undefined) 
    {
      this.signup.order = new Order();
    }
    if(this.signup.order.candidate == undefined)
    {
      this.signup.order.candidate = new Candidate();
    }
    if(this.signup.order.currentAddress == undefined)
    {
      this.signup.order.currentAddress = new CurrentAddress();
    }
    if(this.appComponent.partner == false)
    {
      this.handleRefresh();
    }
  }

  buildForm(){
    this.form = this.formBuilder.group({
      candidate: this.formBuilder.group({
        firstName: [this.signup.order.candidate.firstName != undefined ? this.signup.order.candidate.firstName : '', [Validators.required, Validators.pattern('[a-z A-Z  -\/:-@\[-\`{-~]+$'), EmptyStringValidator]],
        lastName: [this.signup.order.candidate.lastName != undefined ? this.signup.order.candidate.lastName : '', [Validators.required, Validators.pattern('[a-z A-Z  -\/:-@\[-\`{-~]+$'), EmptyStringValidator]],
        email: [this.signup.order.candidate.email != undefined ? this.signup.order.candidate.email : '', [Validators.required, Validators.email]],
        confirmEmail: ['', Validators.required],
      },
        {
          validator: MustMatch('email', 'confirmEmail')
        })
    })
  }

  ngAfterViewInit(): void {
    this.innerWidth = window.innerWidth;
    this.handleViewChange();
  }

  handleViewChange(): void {
    if (this.innerWidth <= breakpointPixels.md) {
      this.backButtonAlignment = "center";
      this.nextButtonAlignment = "center";
    }
    else {
      this.backButtonAlignment = "right";
      this.nextButtonAlignment = "left";
    }
  }

  handleRefresh(){
    this.appComponent.partner = true;
    var logo = this.signup.partner.logoImageContentType + this.signup.partner.logo;
    this.appComponent.partnerLogo = logo; 
  }
  
  selectOrderType(order: string): void {
    this.form.patchValue({ ordertype: order });
    this.signup.ordertype = orderType[order];
    this.router.navigate(['/partner/online']);
  }

  // submit order, move to next step
  onSubmit() {
    this.submitted = true;
    this.loading = true;

    if (this.form.invalid) {
      this.loading = false;
      return;
    }

    this.signup.candidateemail = (this.form.get('candidate') as UntypedFormGroup).controls.email.value;
    this.signup.candidatefirstname = (this.form.get('candidate') as UntypedFormGroup).controls.firstName.value;
    this.signup.candidatelastname = (this.form.get('candidate') as UntypedFormGroup).controls.lastName.value;

    this.signup.order.candidate.firstName = (this.form.get('candidate') as UntypedFormGroup).controls.firstName.value;
    this.signup.order.candidate.lastName = (this.form.get('candidate') as UntypedFormGroup).controls.lastName.value;
    this.signup.order.candidate.email = (this.form.get('candidate') as UntypedFormGroup).controls.email.value;

    Object.keys(this.form.value).forEach(x => {
      this.signup[x] = this.form.value[x];
    })

    this.signupService.saveCandidateDetails(this.signup);
    this.router.navigate(['/partner/payment'])
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  onCancel() {
    this.router.navigate(['/partner/candidate'])
  }

  handleApplicantDocPreview() {
    this.signupService.getLegalForm(this.esignGuid).subscribe(x => {
      this.candidateEsignAuth = x;
    });
    this.signupService.getLegalForm(this.disclosureGuid).subscribe(x => {
      this.candidateDisclosure = x;
    });
    this.signupService.getLegalForm(this.stateFormsGuid).subscribe(x => {
      this.candidateStateForms = x;
    });
    this.signupService.getLegalForm(this.authorizationGuid).subscribe(x => {
      this.candidateAuthorization = x;
    });

    this.electronicsignaturemodal.show();
  }

  //switch x, passed from decline button, hide shown modal and all previous, cleaner preview
  decline(x: number): void {
    switch (x) {
      case 1:
        this.electronicsignaturemodal.hide();
        break;
      case 2:
        this.electronicsignaturemodal.hide();
        this.disclosuremodal.hide();
      case 3:
        this.electronicsignaturemodal.hide();
        this.disclosuremodal.hide();
        this.stateformsmodal.hide();
        break;
      case 4:
        this.disclosuremodal.hide();
        this.stateformsmodal.hide();
        this.authorizationmodal.hide();
        break;
    }
  }

  electronicsignature(): void {

    this.electronicsignaturemodal.hide();
    this.disclosuremodal.show();
  }

  disclosure(): void {
    this.disclosuremodal.hide();
    this.stateformsmodal.show();
  }

  stateForms(): void {
    this.electronicsignaturemodal.hide();
    this.authorizationmodal.show();
  }

}
